import React from "react";
import { GradeAttributeCardWrapper } from "./styles";
import { Ptag } from "components/core";
import { formatPlanOverviewValue } from "utlis/utils";

function GradeAttributeCard({ title, limit, remarks, children }) {

  // if (!limit || !remarks || !children) return null;
  return (
    <GradeAttributeCardWrapper>
      <header>
        <Ptag color="white">{title}</Ptag>
      </header>
      {children ? (
        <article>{children}</article>
      ) : (
        <article>
          <Ptag fontWeight="400" color="#4a4a4a" marginBottom="8px">
            Limit
          </Ptag>
          <Ptag fontWeight="700" color="#4a4a4a" fontSize="16px">
            {formatPlanOverviewValue(limit)}
          </Ptag>
          {remarks && (
            <Ptag fontWeight="400" color="#4a4a4a" marginTop="18px" letterHeight="18px">
              Remarks: {remarks}
            </Ptag>
          )}
        </article>
      )}
    </GradeAttributeCardWrapper>
  );
}

export default GradeAttributeCard;
